function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_930",
  "data-name": "Group 930",
  transform: "translate(-108 -517)"
}, /*#__PURE__*/React.createElement("g", {
  id: "build-24px",
  transform: "translate(113 522)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_197",
  "data-name": "Path 197",
  d: "M0,0H20.229V20.229H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_198",
  "data-name": "Path 198",
  d: "M14.621,12.349,8.9,6.63a4.033,4.033,0,0,0-.943-4.336,4.154,4.154,0,0,0-4.65-.817l2.7,2.7L4.126,6.065l-2.765-2.7a4.05,4.05,0,0,0,.817,4.65,4.033,4.033,0,0,0,4.336.943l5.719,5.719a.607.607,0,0,0,.88,0l1.445-1.445a.566.566,0,0,0,.063-.88Z",
  transform: "translate(2.212 1.256)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_929",
  "data-name": "Group 929",
  transform: "translate(-1142.491 308.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_343",
  "data-name": "Group 343",
  transform: "translate(1250.491 208.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_100",
  "data-name": "Ellipse 100",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.8
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14.519,
  cy: 14.519,
  r: 14.519,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.519,
  cy: 14.519,
  r: 13.619,
  fill: "none"
})))));

var SvgAccountSettingsIcon = function SvgAccountSettingsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.038,
    height: 29.038,
    viewBox: "0 0 29.038 29.038",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountSettingsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account-settings-icon.2a05d98c.svg";
export { ForwardRef as ReactComponent };